// src/services/securityService.js
import axios from "axios";
import { buildHeaders } from "./_headers.util";

const API_URL = process.env.VUE_APP_API_URL || "http://127.0.0.1:8000/api/";

class SecurityService {
  changePassword(payload) {
    return axios.post(API_URL + "security/change-password", payload, {
      headers: buildHeaders(),
    });
  }

  getDevices() {
    return axios.get(API_URL + "security/devices", {
      headers: buildHeaders(),
    });
  }

  revokeDevice(id) {
    return axios.delete(API_URL + `security/devices/${id}`, {
      headers: buildHeaders(),
    });
  }

  getActivity() {
    return axios.get(API_URL + "security/activity", {
      headers: buildHeaders(),
    });
  }

  deleteAccount(payload) {
    return axios.post(API_URL + "security/delete-account", payload, {
      headers: buildHeaders(),
    });
  }

  // 👇 NEW: deactivate (soft shutdown)
  deactivateAccount(payload) {
    return axios.post(API_URL + "security/deactivate-account", payload, {
      headers: buildHeaders(),
    });
  }
}

export default new SecurityService();
